function waitForDirective() {
    'ngInject';

    return {
        transclude: false,
        restrict: 'A',
        priority: 800,
        link(scope, element, attrs) {
            let name = attrs.bbWaitVar;
            if (!name) {
                name = 'allDone';
            }
            scope[name] = false;
            const prom = scope.$eval(attrs.bbWaitFor);
            if (!prom) {
                scope[name] = true;
            } else {
                prom.then(() => scope[name] = true);
            }
        }
    };
}

angular
    .module('BB')
    .directive('bbWaitFor', waitForDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/wait-for/wait_for.directive.js